module.exports = __webpack_public_path__ + "static/government-of-canada-logo-9fceebf3aad2d2ffe1aae067b55f3194.png";